module.exports = __webpack_public_path__ + "static/media/add-new-risk.aedf2487.svg";